// extracted by mini-css-extract-plugin
module.exports = {"row":"JournalExecSection_row__2unBl","parent":"JournalExecSection_parent__1Jcf4","name":"JournalExecSection_name__3i3XU"};